import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useState } from "react";
import { PrintDetails } from "./PrintDetails";
import { CertificateForm } from "./CertificateForm";

interface PrintDetailsDialogProps {
  print: any;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PrintDetailsDialog({ print, open, onOpenChange }: PrintDetailsDialogProps) {
  const [issuingCertificate, setIssuingCertificate] = useState(false);

  if (!print) return null;

  return (
    <>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-3xl">
          <DialogHeader>
            <DialogTitle className="text-xl">
              Print Details
            </DialogTitle>
          </DialogHeader>
          
          <PrintDetails
            print={print}
            onIssueCertificate={() => setIssuingCertificate(true)}
            onOpenChange={onOpenChange}
          />
        </DialogContent>
      </Dialog>

      <CertificateForm
        print={print}
        open={issuingCertificate}
        onOpenChange={setIssuingCertificate}
      />
    </>
  );
}